
import LikeDislike from "../../../assets/duotone/LikeDislike.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LikeDislikeIcon({ className, dataTestid = "LikeDislikeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LikeDislike data-testid={dataTestid} className={classes} {...rest} />
  );
}
